var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFastForwardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 30,
    viewBox: "0 0 61 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 12.8349C26.9167 13.7972 26.9167 16.2028 25.25 17.1651L11.75 24.9593C10.0833 25.9215 8 24.7187 8 22.7942L8 7.20577C8 5.28127 10.0833 4.07846 11.75 5.04071L25.25 12.8349Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.523 12.8349C42.1896 13.7972 42.1896 16.2028 40.5229 17.1651L27.0229 24.9593C25.3563 25.9215 23.2729 24.7187 23.2729 22.7942L23.2729 7.20577C23.2729 5.28127 25.3563 4.07846 27.0229 5.04071L40.523 12.8349Z",
    fill: "black",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7954 12.8349C57.4621 13.7972 57.4621 16.2028 55.7954 17.1651L42.2954 24.9593C40.6287 25.9215 38.5454 24.7187 38.5454 22.7942L38.5454 7.20577C38.5454 5.28127 40.6287 4.07846 42.2954 5.04071L55.7954 12.8349Z",
    fill: "black",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastForwardIcon);
export default __webpack_public_path__ + "static/media/fast-forward-icon.8c2146ffa904efa729833a4d62c87133.svg";
export { ForwardRef as ReactComponent };